import type { ReactNode } from "react";

import { type QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import { getClientEnv } from "@shared/libs/runtime-env";

type Props = {
  children?: ReactNode;
  nonce?: string;
  queryClient: QueryClient;
};
export const ApiProvider = ({ children, nonce, queryClient }: Props) => {
  const isDev = getClientEnv("DEV", false);
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {isDev && (
        <div style={{ bottom: "60px", left: "12px", position: "fixed" }}>
          <ReactQueryDevtools
            buttonPosition="relative"
            client={queryClient}
            position="left"
            styleNonce={nonce}
          />
        </div>
      )}
    </QueryClientProvider>
  );
};
